import Track1 from "../../assets/Pop/pop1.png"
import Track2 from "../../assets/Pop/pop2.png"
import Track3 from "../../assets/Pop/pop3.png"
import Track4 from "../../assets/Pop/pop4.png"
import Track5 from "../../assets/Pop/pop5.png"
import Track6 from "../../assets/Pop/pop6.png"
import Track7 from "../../assets/Pop/pop7.png"
import Track8 from "../../assets/Pop/pop8.png"
import Track9 from "../../assets/Pop/pop9.png"
import Track10 from "../../assets/Pop/pop10.png"
import Track11 from "../../assets/Pop/pop11.png"
import Track12 from "../../assets/Pop/pop12.png"
import Track13 from "../../assets/Pop/pop13.png"
import Track14 from "../../assets/Pop/pop14.png"
import Track15 from "../../assets/Pop/pop15.png"
import Track16 from "../../assets/Pop/pop16.png"
import Track17 from "../../assets/Pop/pop17.png"
import Track18 from "../../assets/Pop/pop18.png"
import Track19 from "../../assets/Pop/pop19.png"
import Track20 from "../../assets/Pop/pop20.png"
import Track21 from "../../assets/Pop/pop21.png"
import Track22 from "../../assets/Pop/pop22.png"
import Track23 from "../../assets/Pop/pop23.png"
import Track24 from "../../assets/Pop/pop24.png"
import Track25 from "../../assets/Pop/pop25.png"
import Track26 from "../../assets/Pop/pop26.png"
import Track27 from "../../assets/Pop/pop27.png"
import Track28 from "../../assets/Pop/pop28.png"
import Track29 from "../../assets/Pop/pop29.png"
import Track30 from "../../assets/Pop/pop30.png"
import Track31 from "../../assets/Pop/pop31.png"
import Track32 from "../../assets/Pop/pop32.png"
import Track33 from "../../assets/Pop/pop33.png"
import Track34 from "../../assets/Pop/pop34.png"
import Track35 from "../../assets/Pop/pop35.png"
import Track36 from "../../assets/Pop/pop36.png"
const PopModernData = [
    {
        id: "1",
        img: Track1,
        title: "Great American Songbook",
        artist: "Frank Sinatra",
        price: "63",
        cat: "Fairuz",
        lang: "Arabic",
        category: "Pop Modern",
    },
    {
        id: "2",
        img: Track2,
        title: "Platinum Collection",
        artist: "Frank Sinatra",
        price: "70",
        category: "Pop Modern",
    },
    {
        id: "3",
        img: Track3,
        title: "Single Collection",
        artist: "Frank Sinatra",
        price: "70",
        category: "Pop Modern",
    },
    {
        id: "4",
        img: Track4,
        title: "A Head Full of Dreams",
        artist: "Coldplay",
        price: "62",
        category: "Pop Modern",
    },
    {
        id: "5",
        img: Track5,
        title: "Prachutes",
        artist: "Coldplay",
        price: "45",
        category: "Pop Modern",
    },
    {
        id: "6",
        img: Track6,
        title: "Like A Virgin",
        artist: "Madonna",
        price: "50",
        category: "Pop Modern",
    },
    {
        id: "7",
        img: Track7,
        title: "Bad",
        artist: "Michael Jackson",
        price: "55",
        category: "Pop Modern",
    },
    {
        id: "8",
        img: Track8,
        title: "Dangerous",
        artist: "Michael Jackson",
        price: "57",
        category: "Pop Modern",
    },
    {
        id: "9",
        img: Track9,
        title: "HIstory Continues",
        artist: "Michael Jackson",
        price: "82",
        category: "Pop Modern",
    },
    {
        id: "10",
        img: Track10,
        title: "Off The Wall",
        artist: "Michael Jackson",
        price: "55",
        category: "Pop Modern",
    },
    {
        id: "11",
        img: Track11,
        title: "Xscape",
        artist: "Michael Jackson",
        price: "52",
        category: "Pop Modern",
    },
    {
        id: "12",
        img: Track12,
        title: "A Collection Of Great Dance Songs",
        artist: "Pink Floyd",
        price: "52",
        category: "Pop Modern",
    },
    {
        id: "13",
        img: Track13,
        title: "A Saucerful Of Secrets Stereo",
        artist: "Pink Floyd",
        price: "52",
        category: "Pop Modern",
    },
    {
        id: "14",
        img: Track14,
        title: "The Dark Side Of The Moon",
        artist: "Pink Floyd",
        price: "65",
        category: "Pop Modern",
    },
    {
        id: "15",
        img: Track15,
        title: "The Wall",
        artist: "Pink Floyd",
        price: "77",
        category: "Pop Modern",
    },
    {
        id: "16",
        img: Track16,
        title: "Pink Floyd At Pompeii MCMLXXII",
        artist: "Pink Floyd",
        price: "80",
        category: "Pop Modern",
    },
    {
        id: "17",
        img: Track17,
        title: "Ummagumma",
        artist: "Pink Floyd",
        price: "75",
        category: "Pop Modern",
    },
    {
        id: "18",
        img: Track18,
        title: "Wish You Were Here",
        artist: "Pink Floyd",
        price: "60",
        category: "Pop Modern",
    },
    {
        id: "19",
        img: Track19,
        title: "Bohemian Rhapsody (The Original Soundtrack)",
        artist: "Queen",
        price: "77",
        category: "Pop Modern",
    },
    {
        id: "20",
        img: Track20,
        title: "Greatest Hits II",
        artist: "Queen",
        price: "75",
        category: "Pop Modern",
    },
    {
        id: "21",
        img: Track21,
        title: "The Life Of A Showgirl",
        artist: "Taylor Swift",
        price: "75",
        category: "Pop Modern",
    },
    {
        id: "22",
        img: Track22,
        title: "ABBA – The Album",
        artist: "ABBA",
        price: "62",
        category: "Pop Modern",
    },
    {
        id: "23",
        img: Track23,
        title: "Gold",
        artist: "ABBA",
        price: "62",
        category: "Pop Modern",
    },
    {
        id: "24",
        img: Track24,
        title: "Ring Ring",
        artist: "ABBA",
        price: "62",
        category: "Pop Modern",
    },
    {
        id: "25",
        img: Track25,
        title: "Super Trouper",
        artist: "ABBA",
        price: "62",
        category: "Pop Modern",
    },
    {
        id: "26",
        img: Track26,
        title: "The Singles (The First 50 Years)",
        artist: "ABBA",
        price: "224",
        category: "Pop Modern",
    },
    {
        id: "27",
        img: Track27,
        title: "Waterloo",
        artist: "ABBA",
        price: "62",
        category: "Pop Modern",
    },
    {
        id: "28",
        img: Track28,
        title: "The Visitors",
        artist: "ABBA",
        price: "62",
        category: "Pop Modern",
    },
    {
        id: "29",
        img: Track29,
        title: "Voulez-Vous",
        artist: "ABBA",
        price: "62",
        category: "Pop Modern",
    },
    {
        id: "30",
        img: Track30,
        title: "Ultimate",
        artist: "Bryan Adams",
        price: "62",
        category: "Pop Modern",
    },
    {
        id: "31",
        img: Track31,
        title: "A Joolly Christmas From Frank Sinatra",
        artist: "Frank Sinatra",
        price: "62",
        category: "Pop Modern",
    },
    {
        id: "32",
        img: Track32,
        title: "Mettalica",
        artist: "Metallica",
        price: "77",
        category: "Pop Modern",
    },
    {
        id: "33",
        img: Track33,
        title: "S&M",
        artist: "Metallica , Michael Kamen The , The San Francisco Symphony Orchestra",
        price: "77",
        category: "Pop Modern",
    },
    {
        id: "34",
        img: Track34,
        title: "Incesticide",
        artist: "Nirvana",
        price: "77",
        category: "Pop Modern",
    },
    {
        id: "35",
        img: Track35,
        title: "Jazz",
        artist: "Queen",
        price: "62",
        category: "Pop Modern",
    },
    {
        id: "36",
        img: Track36,
        title: "Made In Heaven",
        artist: "Queen",
        price: "77",
        category: "Pop Modern",
    },
]
export default PopModernData;